import React, { useState } from 'react';
import Layout from 'layouts/manager/Layout';
import ContractSection from '../member/ContractSection';

const CONTRACT_PLANS = [
  { value: 'basic', label: 'ベーシック' },
  { value: 'premium', label: 'プレミアム' },
  { value: 'custom', label: 'カスタム' },
];
const CONTRACT_PAYMENT_METHODS = [
  { value: 'bank', label: '銀行振込' },
  { value: 'credit', label: 'クレジットカード' },
  { value: 'paid', label: 'Paid' },
  { value: 'other', label: 'その他' },
];
const CONTRACT_STATUSES = [
  { value: 'active', label: '有効' },
  { value: 'inactive', label: '無効' },
  { value: 'cancelled', label: '解約' },
];

const Edit: React.FC = () => {
  const [contracts, setContracts] = useState([
    {
      plan: '',
      fee: '',
      appliedAt: '',
      startedAt: '',
      renewedAt: '',
      paymentMethod: '',
      usageCount: '',
      annualUsageCount: '',
      status: 'active',
      agencyNo: '',
      agencyName: '',
    },
  ]);

  return (
    <Layout>
      <div className="flex items-center justify-between mx-auto mb-8">
        <h1 className="text-2xl font-bold text-gray-800">契約情報編集</h1>
      </div>
      <div className="p-8 mx-auto bg-white border border-gray-200 rounded-lg shadow-md">
        <div className="mb-3">
          <a href="/manager/contract" className="text-sm text-gray-500 underline transition hover:text-gray-700">&lt; 一覧画面に戻る</a>
        </div>
        <ContractSection
          open={true}
          setOpen={() => {}}
          contracts={contracts}
          setContracts={setContracts}
          CONTRACT_PLANS={CONTRACT_PLANS}
          CONTRACT_PAYMENT_METHODS={CONTRACT_PAYMENT_METHODS}
          CONTRACT_STATUSES={CONTRACT_STATUSES}
        />
        <div className="flex items-center justify-between gap-4 mt-8">
          <a href="/manager/contract" className="text-sm text-gray-500 underline transition hover:text-gray-700">&lt; 一覧画面に戻る</a>
          <button type="submit" form="" className="px-6 py-2 min-w-[120px] font-semibold text-white rounded bg-primary hover:bg-[#001b40] transition text-sm shadow">保存</button>
        </div>
      </div>
    </Layout>
  );
};

export default Edit;
